import React from "react";

// Custom Components
import EntryDataTableTemplate from "../../../../../../components/DataTable/EntryDataTableTemplate";

function SegmentationMenuScreen() {
  return (
    <EntryDataTableTemplate
      apiPath={"entries/segmentation_menu/"}
      newItemPath={"/entries/segmentation_entry/"}
      dataTableName={"Body Segmentation Entries"}
      showCreateEntryButton={true}
    />
  );
}

export default SegmentationMenuScreen;
